import(/* webpackMode: "eager" */ "/app/src/app/agb/page.tsx");
